import { type HTMLArkProps, ark } from '@ark-ui/react';

import { cn } from '../../lib/utils';

interface SkeletonProps extends HTMLArkProps<'div'> {
	loading?: boolean;
}

function Skeleton({ className, loading = true, children, ...props }: SkeletonProps) {
	if (!loading) return <>{children}</>;

	return (
		<ark.div
			data-slot="skeleton"
			aria-hidden="true"
			className={cn(
				'pt-skeleton',
				children ? 'pt-skeleton-wrap' : 'pt-skeleton-standalone',
				className
			)}
			{...props}
		>
			{children}
		</ark.div>
	);
}

export { Skeleton, type SkeletonProps };
